import { getToastCopy } from "@/features/i18n/toastCopy";

/** Supabase returns a generic message when SMS OTP is blocked for unknown numbers (`shouldCreateUser: false`). */
export function smsOtpUserFacingMessage(rawMessage: string): string {
    const copy = getToastCopy();
    const lower = rawMessage.toLowerCase();
    if (
        lower.includes("signups not allowed") ||
        lower.includes("signup not allowed") ||
        lower.includes("sign ups not allowed")
    ) {
        return copy.smsVerificationTextFailedSignup;
    }
    if (lower.includes("sms") && (lower.includes("not enabled") || lower.includes("disabled"))) {
        return copy.smsSignInNotEnabledForProject;
    }
    if (lower.includes("unprocessable") || lower.includes("422")) {
        return copy.smsCouldNotSendCheckNumber;
    }
    return rawMessage;
}

/**
 * After `public-smart-auth` has already matched an account; GoTrue can still return "signups not allowed" or 422.
 * Avoid implying the user has no account.
 */
export function smsOtpLoginAfterLookupMessage(rawMessage: string, errorCode?: string): string {
    const copy = getToastCopy();
    const code = (errorCode ?? "").toLowerCase();
    if (code === "otp_disabled") {
        return copy.smsLoginTextFailedOtpDisabled;
    }
    const lower = rawMessage.toLowerCase();
    if (
        lower.includes("signups not allowed") ||
        lower.includes("signup not allowed") ||
        lower.includes("sign ups not allowed")
    ) {
        return copy.smsLoginTextFailedAccountFound;
    }
    return smsOtpUserFacingMessage(rawMessage);
}
